export interface UserNotificationMessagesCountInterface{
  userId?: string;
  notificationsCount?: number;
  messagesCount?: number;
}
